import React from "react";
import { Tooltip } from "../../text/Tooltip";

const MetricCard = ({
  title,
  description,
  options,
  onOptionSelect,
  isOptionSelected,
  colorClass = "style-primary",
}) => {
  const card = (
    <div className="min-h-[7.5rem] h-full bg-white rounded-lg shadow-md border border-style-border flex flex-col justify-between overflow-hidden">
      <div className="flex-1 flex items-center justify-center w-full px-4 py-3">
        <div className="font-inter text-style-text-dark text-sm text-center break-words">
          {title}
        </div>
      </div>
      <div className="p-2 flex flex-wrap gap-1 justify-center">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => onOptionSelect(option)}
            className={`font-inter text-sm px-2 py-1 rounded border transition-all
              ${
                isOptionSelected(option)
                  ? `bg-${colorClass}/10 text-${colorClass} font-medium ring-1 ring-${colorClass} border-${colorClass}`
                  : "text-style-text-dark border-style-border bg-style-bg hover:border-style-primary hover:bg-style-bg/70 cursor-pointer"
              }`}
            style={{ minWidth: "2.5rem" }}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );

  if (!description?.trim()) {
    return card;
  }

  return <Tooltip content={description}>{card}</Tooltip>;
};

export { MetricCard };
